import {
    Button,
    Modal,
    ModalActions,
    ModalContent,
    ModalHeader,
} from '@/platform/ui';
import { usePage } from '@inertiajs/react';
import { useEffect, useState } from 'react';

const twoFactorTypes = {
    google: '(Google) Authenticator (OTP)',
    email: 'Code per e-mail',
    sms: 'Code per SMS',
};

const ChangeTwoFactorTypeMessage = () => {
    const [visible, setVisible] = useState(false);
    const { auth } = usePage().props;

    useEffect(() => {
        const shouldBeHidden =
            import.meta.env.VITE_ENV === 'local' ||
            auth?.user?.sso_only ||
            auth?.user?.allowed_2fa?.includes(auth?.user?.two_factor_type) ||
            auth?.is_impersonated ||
            window.location.pathname === '/account';

        setVisible(!shouldBeHidden);
    }, [auth?.user, window.location.pathname]);

    return (
        <Modal open={visible}>
            <ModalHeader>Let op!</ModalHeader>
            <ModalContent>
                U gebruikt{' '}
                <b>{twoFactorTypes[auth?.user?.two_factor_type] || 'Geen'}</b>{' '}
                als tweestapsverificatie. We raden aan om het te veranderen in:
                <ul className='mt-2 list-disc space-y-1 pl-5 text-sm text-black'>
                    {auth?.user?.allowed_2fa?.map(option => (
                        <li key={option}>{twoFactorTypes[option]}</li>
                    ))}
                </ul>
            </ModalContent>
            <ModalActions>
                <Button
                    // as={Link}
                    as='a'
                    href='/account'
                    variant='primary'
                >
                    Verander Tweestapsverificatie
                </Button>
            </ModalActions>
        </Modal>
    );
};

export default ChangeTwoFactorTypeMessage;
